import React from 'react';
import { Field } from 'redux-form';
import { Col, FormGroup } from 'react-bootstrap';
import { PublicCheckbox } from '../../../../common/components';
import {
  WhiteLabelContentContainer
} from '../WLContentContainer/WhiteLabelContentContainer';

const InsuranceMarketingOptions = ({ enabled }) => {
  return (
    <WhiteLabelContentContainer title={'Insurance Marketing Options'}>
     <>
        <FormGroup>
          <Col sm={12}>
            <Field
              name={'meta.whitelabel.insurance_marketing_options.enabled'}
              component={PublicCheckbox}
              label={'Enabled'}
            />
          </Col>
        </FormGroup>
        {enabled && (
          <>
            <FormGroup>
              <Col sm={12}>
                <Field
                  name={
                    'meta.whitelabel.insurance_marketing_options.home_insurance_marketing_enabled'
                  }
                  component={PublicCheckbox}
                  label={'Home Insurance Marketing Enabled'}
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col sm={12}>
                <Field
                  name={
                    'meta.whitelabel.insurance_marketing_options.car_insurance_marketing_enabled'
                  }
                  component={PublicCheckbox}
                  label={'Car Insurance Marketing Enabled'}
                />
              </Col>
            </FormGroup>
          </>
        )}
     </>
    </WhiteLabelContentContainer>

  );
};
export default InsuranceMarketingOptions;
